__turbopack_context__.v({
  "cell": "grid-view-module__hCzOrG__cell",
  "grid": "grid-view-module__hCzOrG__grid",
  "header": "grid-view-module__hCzOrG__header",
  "headersWrapper": "grid-view-module__hCzOrG__headersWrapper",
  "leftJustify": "grid-view-module__hCzOrG__leftJustify",
  "level": "grid-view-module__hCzOrG__level",
  "spellColspan": "grid-view-module__hCzOrG__spellColspan",
  "wrapper": "grid-view-module__hCzOrG__wrapper",
});
